"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.epochToDate = exports.getCurrentEpoch = exports.getCurrentSolanaTimestamp = void 0;
const constants_1 = require("../constants");
const getCurrentSolanaTimestamp = async (connection) => {
    const slot = await connection.getSlot();
    const blockTime = await connection.getBlockTime(slot);
    if (blockTime === null) {
        throw new Error("Block time is not available");
    }
    return BigInt(blockTime);
};
exports.getCurrentSolanaTimestamp = getCurrentSolanaTimestamp;
const getCurrentEpoch = async (connection) => {
    const timestamp = await (0, exports.getCurrentSolanaTimestamp)(connection);
    return timestamp / constants_1.EPOCH_DURATION;
};
exports.getCurrentEpoch = getCurrentEpoch;
const epochToDate = (epoch) => {
    return new Date(Number(epoch * constants_1.EPOCH_DURATION * 1000n));
};
exports.epochToDate = epochToDate;
